/** Per-language translation maps. Free-text fields that vary by language
 *  (Specialty.name, Specialist.title/bio/displayName) are stored as a JSON map
 *  keyed by locale code, e.g. `{ "bg": "Кардиолог", "en": "Cardiology" }`. The
 *  keys mirror the web's SUPPORTED_LANGUAGES — adding a language is just adding
 *  a key, no schema change. */
/** Coerce an unknown DB value into a translation map (defensive: the column is
 *  `Json`, so it may be null, a string, or a malformed object). */
export function asTranslations(value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        const out = {};
        for (const [k, v] of Object.entries(value)) {
            if (typeof v === 'string')
                out[k] = v;
        }
        return out;
    }
    return {};
}
/** Read a translation for `lang`, falling back to the first non-empty value
 *  among `fallbacks` (default: bg, en), then any non-empty value. Returns ''
 *  when nothing is set. A bare string value (legacy/unmigrated) is returned
 *  as-is regardless of language. */
export function pickLang(value, lang, fallbacks = ['bg', 'en']) {
    if (typeof value === 'string')
        return value;
    const t = asTranslations(value);
    if (t[lang]?.trim())
        return t[lang];
    for (const f of fallbacks) {
        if (f !== lang && t[f]?.trim())
            return t[f];
    }
    for (const v of Object.values(t)) {
        if (v.trim())
            return v;
    }
    return '';
}
